import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import './components.css';

export default function Navbar() {
  const [user, setUser] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [userFullName, setUserFullName] = useState('');
  const [userRole, setUserRole] = useState('');
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const isAdminSubdomain = window.location.hostname.startsWith('admin.');

  // 🔹 Load user on mount
  useEffect(() => {
    const getUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setUser(user);
    };
    getUser();

    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user || null);
    });

    return () => listener?.subscription.unsubscribe();
  }, []);

  // 🔹 Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // 🔹 Fetch full name & role
  useEffect(() => {
    const fetchUserDetails = async () => {
      if (user) {
        const { data } = await supabase
          .from('users')
          .select('full_name, role')
          .eq('id', user.id)
          .single();

        if (data) {
          setUserFullName(data.full_name || '');
          setUserRole(data.role || 'user');
        }
      } else {
        setUserFullName('');
        setUserRole('');
      }
    };
    fetchUserDetails();
  }, [user]);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setUser(null);
    navigate('/');
  };

  return (
    <header className="header">
      <nav className="navbar-boxed">
        <div className="nav-logo">
          <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
            EVENT<span>FIND</span>
          </Link>
        </div>

        <ul className="nav-menu">
          <li>
            <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
              Home
            </Link>
          </li>
         

          {/* ✅ Show Admin Dashboard link only for admins */}
          {userRole === 'admin' && (
            <li>
              {isAdminSubdomain ? (
                <Link
                  to="/admin"
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  Dashboard
                </Link>
              ) : (
                <a
                  href="https://admin.eventfind.me/admin"
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  Dashboard
                </a>
              )}
            </li>
          )}
        </ul>

        {!user ? (
          <Link to="/login">
            <button className="nav-register">Login</button>
          </Link>
        ) : (
          <div className="nav-profile" ref={dropdownRef}>
            <button
              className="profile-button"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              {(userFullName?.charAt(0) || 'U').toUpperCase()}
            </button>

            {menuOpen && (
              <div className="profile-dropdown">
                <button
                  className="dropdown-item"
                  onClick={() => {
                    if (userRole === 'admin') {
                      if (isAdminSubdomain) {
                        navigate('/admin');
                      } else {
                        window.location.href = 'https://admin.eventfind.me/admin';
                      }
                    } else {
                      navigate('/profile');
                    }
                    setMenuOpen(false);
                  }}
                >
                  Profile
                </button>

                <button onClick={handleLogout} className="dropdown-item">
                  Logout
                </button>
              </div>
            )}
          </div>
        )}
      </nav>
    </header>
  );
}
